import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { PunchCardIconProvider } from '../../providers/punch-card-icon';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-punch-card-icon-select',
  templateUrl: 'business-punch-card-icon-select.html',
})
export class BusinessPunchCardIconSelectPage {
	icons: any;

	page: any = 1;
	size: any = 20;
	term: any = "null";

	isLoading: boolean = false;
	isFetchingMore: boolean = false;
	isRefreshing: boolean = false;
	lastRequestReturnedValues: boolean = false;

	constructor(
		public navCtrl: NavController, 
		public globals: Globals, 
		public punchCardIconProvider: PunchCardIconProvider, 
		public navParams: NavParams) {
	}

	ionViewDidLoad() {
		this.load(null);
	}

	doRefresh(refresher) {
		this.isRefreshing = true;
		this.page = 1;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  		

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isFetchingMore = true;
		this.page++;

		this.load(()=>{
			this.isFetchingMore = false;
			infiniteScroll.complete();
		});
	}	

	search(ev){
		this.term = this.term = ev.target.value;	
		this.icons = [];

		if(this.term=="" || !this.term)
			this.term = "null";
		
		this.page = 1;

		this.load(null);
	}

	load(cb){
		this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

		this.punchCardIconProvider.getPunchCardIcons(
		{
			term: this.term,
			page: this.page,
			size: this.size,			
			cb: (icons)=>{
				this.lastRequestReturnedValues = (icons.length==0) ? false : true;

				if(this.page == 1){
					this.icons = icons;	
				}else{
					for (var i = icons.length - 1; i >= 0; i--) {
						this.icons.push(icons[i]);
					}					
				}

				this.isLoading = false;

				if(typeof cb == "function")
					cb()					
			}
		})		
	}

	selectIcon(icon){
		this.punchCardIconProvider.icon = icon;

		this.navCtrl.pop();
	}
}



// WEBPACK FOOTER //
// ./src/pages/business-punch-card-icon-select/business-punch-card-icon-select.ts